export default "__VITE_ASSET__6c108c3d__"